import script from "./FastRecharge.vue?vue&type=script&setup=true&lang=js"
export * from "./FastRecharge.vue?vue&type=script&setup=true&lang=js"

import "./FastRecharge.vue?vue&type=style&index=0&id=2ab5dde4&scoped=true&lang=less"
import "./FastRecharge.vue?vue&type=style&index=1&id=2ab5dde4&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab5dde4"]])

export default __exports__